const getIsMobile = () => window.innerWidth <= 414;

export { getIsMobile };
